import { assignCommonProperties } from '../util/data/assign-common-properties.js'

import {
	jsonClass,
	jsonProperty,
	jsonArrayProperty,
} from '@sumbricht/json-class-serializer'
import { Parameter } from './parameter.js'
import { Code } from '../types.js'

export const ComputationDefinitionTypes = {
	sync: 'Synchronous',
	async: 'Asynchronous',
} as const
export type ComputationDefinitionType = keyof typeof ComputationDefinitionTypes

@jsonClass('ComputationDefinition')
export class ComputationDefinition {
	@jsonProperty(String) name = ''
	@jsonProperty(String) type: ComputationDefinitionType = 'sync'
	@jsonProperty(Boolean) isStatic: boolean = false
	@jsonProperty(Code) asyncParameterCode = new Code()
	@jsonProperty(Code) computationCode = new Code()

	constructor(init?: Partial<ComputationDefinition>) {
		assignCommonProperties(this, init)
	}
}
